import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { HeaderService } from '../../@theme/components/header/header.service';
import { AuthenticationService } from '../services/authentication.service';
import { EncriptyUtilService } from '../services/encripty-util.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  public creditoPlano = null;
  public creditoPortal = null;
  public emissaoCartao = null;
  public estornoPlano = null;
  public gastosCartoes = null;
  public saldoDisponivel = null;
  public valorReservado = null;
  public userRoles: Array<any> = [];

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private headerService: HeaderService,
    private encriptyService: EncriptyUtilService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    let productId = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-product-id'));

    if (route.data.roles && route.data.roles.length > 0) {
        let roleList = route.data.roles.map(role => role);

        if(productId == 4){
          this.headerService.getTravelBalances();
        }

        return this.authService.roleVerify(roleList)
        .toPromise()
        .then((res) => {
          if (res.hasPermision === true) {
            return true;
          }else {
            localStorage.clear();
            this.router.navigate(['/login']);
            return false;
          }
        })
        .catch(() => {
          this.router.navigate(['/login']);
          return false;
        });
    }else {
      localStorage.clear();
      this.router.navigate(['/login']);
      return false;
    }
  }

  validateRoles(route: ActivatedRouteSnapshot) {
    if (route.data.roles && route.data.roles.some(role => this.userRoles.indexOf(role) > 0) === false) {
      localStorage.clear();
      this.router.navigate(['/login']);

      return false;
    }
    return true;
  }

}
